export default __webpack_public_path__ + "static/media/ContactFooter.a800a1cd.jpg";